import React from 'react'
import { Card } from 'antd';
const { Meta } = Card;

const Profile = ({

}) => {
  return (
    <div className="white-text">
    <div className="d-flex flex-md-row flex-column">
      <div className="position-relative img-profile mx-auto mx-md-0">
        <div className="bb mx-auto mx-md-0">
          <img src="https://graph.facebook.com/100005406396686/picture?width=800" width="200" height="200"/>
        </div>
      </div>
      <div>
        <p className="name">
          THARATHEP NUMUAN (Jo)
        </p>
        <p className="name">
          Lv.24 Full Stack Pokemon @Pi R Square
        </p>
      </div>
    </div>
      <div className="position-relative">
        <p>
          Important things in my life: Family, Coding,  Money
        </p>
        <p>
          Fav. Country: Japan, EU
        </p>
        <p>
          Next Focus: GraphQL,  NextJS
        </p>
        <p>
          LifeStyle: Sneaker ( NMD, Yeezy )
        </p>
      </div>
    </div>
  )
}

export default Profile


// WEBPACK FOOTER //
// ./src/components/Profile.js